import React from 'react';
import cx from 'classnames';
import styles from './PodiumCard.module.scss';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';

export const PodiumCard = ({ rank, name, statValue, country, flagUrl, photoUrl }) => {
  const isFirst = rank === 1;

  return (
    <div className={cx(styles.card, isFirst && styles.cardFirst)}>
      <div className={styles.imageWrap}>
        {photoUrl
          ? <img src={photoUrl} alt={name} className={styles.photo} />
          : <div className={styles.placeholder} />
        }
        <div className={styles.gradient} />
      </div>

      <div className={styles.info}>
        <p className={styles.name}>{renderMaxLengthText(name, 21)}</p>
        <div className={styles.details}>
          <p className={styles.value}>{statValue ?? '0000'}</p>
          <div className={styles.countryRow}>
            <span className={styles.countryName}>{country}</span>
            {flagUrl && (
              <div className={styles.flagWrap}>
                <img src={flagUrl} alt={country} className={styles.flagImg} />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={styles.rankBadge}>
        <span className={styles.rankNumber}>{rank}</span>
      </div>
    </div>
  );
};
